import React from 'react';
import { Info } from 'lucide-react';

import {
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from "@shared/ui/accordion";
const InfoCard: React.FC = () => {
  return (
<Accordion type="single" collapsible >
  <AccordionItem value="calendar-help">
    <AccordionTrigger className="text-sm font-medium">
      About Calendar & Scheduling
    </AccordionTrigger>
    <AccordionContent>
      <div className="mb-4 rounded-md bg-blue-50 p-4">
        <div className="flex">
          <div className="shrink-0">
            <Info className="h-5 w-5 text-blue-400" aria-hidden="true" />
          </div>
          <div className="ml-3">
            <h3 className="text-sm font-medium text-blue-800">
              About Calendar & Scheduling
            </h3>
            <div className="mt-2 text-sm text-blue-700">
              <p>
                This configuration page allows you to:
              </p>
              <ul role="list" className="list-disc pl-5 space-y-1">
                <li>Set up holidays and non-working days</li>
                <li>Configure working hours for each day</li>
                <li>Import standard holidays for your region</li>
                <li>Manage overtime and special schedules</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </AccordionContent>
  </AccordionItem>
</Accordion>


  );
};

export default InfoCard;